import React from 'react';
import GlobalTheme from './components/GlobalTheme';
import { ConfigContextType, ConfigProvider } from './context/config';
import Carousel from './pages/Carousel';

export interface AppProps {
  config: ConfigContextType;
  brand: UniversalVar.Brand | undefined;
}

const App: React.FC<AppProps> = function App({ config, brand }) {
  return (
    <>
      <GlobalTheme brand={brand} />
      <ConfigProvider value={config}>
        <Carousel />
      </ConfigProvider>
    </>
  );
};

export default App;
